import { internalApiClient } from "../config/internalApiClient";

export interface LoginResponse {
  userId: string;
  [key: string]: unknown;
}

export async function loginUser(whatsappNumber: string): Promise<LoginResponse> {
  const response = await internalApiClient.post(
    "/api/auth/login",
    {
      whatsappNumber,
    },
    {
      toast: {
        successMessage: "OTP sent successfully.",
        errorMessage: "Failed to send OTP. Please try again.",
      },
    }
  );
  return response.data;
}

export async function verifyOtp(whatsappNumber: string, otp: string): Promise<LoginResponse> {
  const response = await internalApiClient.post(
    "/api/auth/verify-otp",
    {
      whatsappNumber,
      otp,
    },
    {
      toast: {
        successMessage: "Login successful.",
        errorMessage: "Invalid or expired OTP. Please try again.",
      },
    }
  );
  return response.data;
}

export async function logoutUser(): Promise<void> {
  await internalApiClient.post("/api/auth/logout");
}

export interface DeleteAccountResponse {
  message: string;
}

export async function deleteAccount(): Promise<DeleteAccountResponse> {
  const response = await internalApiClient.delete(
    "/api/auth/delete-account",
    {
      toast: {
        errorMessage: "Failed to delete your account. Please try again.",
      },
    }
  );

  return response.data;
}